import { GetSubjectDto } from "../api/index.defs";
import { OrderStatus } from "../models/order.interface";

export const getOrderStatus = (studySubject: GetSubjectDto | undefined) => {
  if (!studySubject) return OrderStatus.NewOrderNewSubject;

  const { subjectId, gender, yearOfBirth, nextVisitId, order } = studySubject;

  // open order
  if (order) {
    const { canCancel } = order;
    return canCancel
      ? OrderStatus.OpenOrderCancelable
      : OrderStatus.OpenOrderNotCancelable;
  }

  // new order
  if (subjectId) {
    if (gender && yearOfBirth)
      // subject exists in the study
      return OrderStatus.NewOrderExistingSubject;

    if (!gender && !yearOfBirth && !nextVisitId)
      // subject exists in other study
      return OrderStatus.NewOrderNewSubject;
  }

  return OrderStatus.Unknown;
};
